"use client";

import React from "react";
import { QrCode, BatteryCharging, Zap } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  id: "step-1",
  title: "Scan",
  description: <>
        Open the <span style={{
      color: "#ffe838"
    }}>Zap</span>
        <span style={{
      color: "#70cf70"
    }}>GO!</span> app and scan the QR code on
        the charging station.
      </>,
  icon: QrCode
}, {
  id: "step-2",
  title: "Grab",
  description: "A fully charged powerbank will be released automatically.",
  icon: BatteryCharging
}, {
  id: "step-3",
  title: "Go",
  description: "Charge your device on the go and return it to any station.",
  icon: Zap
}];
export default function RentInThreeSimpleSteps() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="huur-in-drie-simpele-stappen" className="relative bg-background py-24 overflow-hidden" ref={ref}>
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-6 relative z-10 max-w-6xl">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
            Rent in Three Simple Steps
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Quick and easy rental process via the{" "}
            <span style={{
            color: "#ffe838"
          }}>Zap</span>
            <span style={{
            color: "#70cf70"
          }}>GO!</span> app. Never run out of
            phone battery when you need it most.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="absolute top-12 left-[16.66%] right-[16.66%] h-1 hidden md:block bg-border/40 rounded-full overflow-hidden z-0">
            <div className={cn("h-full bg-primary shadow-[0_0_15px_var(--color-primary)] transition-all duration-1500 ease-in-out", isVisible ? "w-full" : "w-0")} />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 relative z-10">
            {steps.map((step, i) => {
            const Icon = step.icon;
            return <div key={step.id} data-index={i} className={cn("flex flex-col items-center text-center transition-all duration-700 ease-out translate-y-8 opacity-0", isVisible && "translate-y-0 opacity-100")} style={{
              transitionDelay: `${i * 200}ms`
            }}>
                  {}
                  <div className="relative w-24 h-24 mb-8 flex items-center justify-center rounded-2xl bg-background/80 backdrop-blur-md border border-primary/30 shadow-[0_0_30px_-5px_var(--color-primary)] group-hover:shadow-[0_0_40px_0px_var(--color-primary)] transition-shadow duration-300">
                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/20 to-transparent opacity-50" />
                    <Icon className="w-10 h-10 text-primary drop-shadow-[0_0_10px_rgba(34,197,94,0.8)] relative z-10" />
                    
                    {}
                    <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-bold text-sm shadow-lg border-2 border-background">
                      {i + 1}
                    </div>
                  </div>

                  {}
                  <Card className="w-full bg-card/30 backdrop-blur-xl border-white/10 dark:border-white/5 shadow-2xl relative overflow-hidden group hover:bg-card/40 transition-colors duration-300">
                    <div className="absolute inset-0 bg-gradient-to-b from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                    <CardHeader className="pb-2">
                      <CardTitle className="text-xl font-bold text-foreground">
                        {step.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-muted-foreground leading-relaxed">
                        {step.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}